import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_TAB_KEY_COUNT,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressTabKeyCountState = number;

const initialState: ContractProgressTabKeyCountState = 0;

export default function reducer(
  state: ContractProgressTabKeyCountState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_TAB_KEY_COUNT:
      return state + 1;
    default:
      return state;
  }
}
